import React, { useState, useEffect } from 'react';
import './scss/AutoSaveStatus.scss';
import CircleCheckOutlined from '../icons/CircleCheckOutlined';

const AutoSaveStatus = ({ autoSaving, lastSaved, className = '' }) => {
  const [showSaved, setShowSaved] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (lastSaved && !autoSaving) {
      setShowSaved(true);
      setFadeOut(false);

      // Start fade out after 2 seconds
      const fadeTimer = setTimeout(() => {
        setFadeOut(true);
      }, 2000);

      // Hide completely after fade animation
      const hideTimer = setTimeout(() => {
        setShowSaved(false);
        setFadeOut(false);
      }, 2500);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    }
  }, [lastSaved, autoSaving]);

  if (autoSaving) {
    return (
      <div className={`auto-save-status saving ${className}`}>
        <span className="material-symbols-outlined spinning">sync</span>
        <span className="status-text">Auto-saving...</span>
      </div>
    );
  }

  if (showSaved ) {
    return (
      <div className={`auto-save-status saved ${fadeOut ? 'fade-out' : ''} ${className}`}>
        <CircleCheckOutlined size={20}  color="var(--success-color, #4caf50)" />
        <span className="status-text">Changes saved automatically</span>
      </div>
    );
  }

  return null;
};

export default AutoSaveStatus;
